import React, { useMemo } from "react";
import PropTypes from 'prop-types';
import { t } from "../../../../helpers/translator";
import Config from "../../../../config/main";

const LiveCasinoProviders = ({ selected, providers, onChange }) => {
    const list = useMemo(() => (
        Config.setOnlyBetcoGames
            ? providers.filter(item => item.provider === 'VGS')
            : providers
    ), [providers]);

    return <div className="l-casino-menu-view">
        <div className="l-casino-provider-nav">
            <ul>
                <li onClick={() => onChange(null)}>
                    {!Config.setOnlyBetcoGames && <p className={!selected ? 'active' : ''}>{t("all")}</p>}
                </li>

                {list.map(item => <li key={item.provider} onClick={() => onChange(item.provider)}>
                    <p className={selected === item.provider ? 'active' : ''}>{t(item.provider_title)}</p>
                </li>)}
            </ul>
        </div>
    </div>;
};

LiveCasinoProviders.propTypes = {
    selected: PropTypes.string,
    providers: PropTypes.array.isRequired,
    onChange: PropTypes.func,
};

export default LiveCasinoProviders;